import Vue from "vue";
import VueRouter, {RouteConfig} from "vue-router";
import Home from "../views/Home.vue";
import Patches from "../views/Patches.vue";
import PageNotFound from "../views/PageNotFound.vue";
import registerTitleWatcher from "@/router/titleWatcher";


Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: "/",
        name: "home",
        component: Home
    },
    {
        path: "/patches",
        name: "patches",
        component: Patches,
        props: {
            filterFeatured: true
        }
    },
    {
        path: "/all_patches",
        name: "allPatches",
        component: Patches,
        props: {
            filterFeatured: false
        }
    },
    {
        path: "/patches/:id",
        name: "patch",
        component: () => import(/* webpackChunkName: "patch" */ "../views/Patch.vue")
    },
    {
        path: "/submit",
        name: "submit",
        component: () => import(/* webpackChunkName: "submit" */ "../views/Submit.vue")
    },
    {
        path: "/submission",
        redirect: "/submit"
    },
    {
        path: "*",
        component: PageNotFound
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if (from.name) {
        document.body.classList.remove("page--" + from.name.toLowerCase());
    }
    if (to.name) {
        document.body.classList.add("page--" + to.name.toLowerCase());
    }
    next();
});

registerTitleWatcher(router);

export default router;
